



































import { PartyContactModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';

@Component({})
export default class ImportantContactsList extends Page {

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    @Prop({ default: false }) readonly!: boolean;

    @VModel() contacts!: PartyContactModel[];

    mounted () {
        this.contacts.forEach((c: PartyContactModel) => {
            if (c.id == Guid.EmptyGuid() || !c.id) {
                this.contacts.splice(this.contacts.indexOf(c), 1);
            }
        });
    }

    private addClick () {
        const newItem: PartyContactModel = {
            partyId: Guid.EmptyGuid(),
            firstName: null,
            lastName: null,
            relationship: null,
            phoneNumber: null
        };
        this.contacts.push(newItem);
        this.onChange();
    }

    private deleteItem (index: number) {
        this.contacts.splice(index, 1);
        this.onChange();
    }
    
    private onChange() {
        this.$emit("change");
    }

}
